import React, { useState, useRef, useEffect } from "react";
import "./scss/HiddenChat.scss";
import { nanoid } from "nanoid";
import { Axios } from "axios";
interface Message {
  content: string;
  isUser: boolean;
  timestamp: Date;
}

const HiddenChat: React.FC = () => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [inputValue, setInputValue] = useState("");
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [sessionId, setSessionId] = useState<string>(nanoid());
  const _axios = new Axios();
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!inputValue.trim()) return;
    const newMessage: Message = {
      content: inputValue,
      isUser: true,
      timestamp: new Date(),
    };
    setMessages((prev) => [...prev, newMessage]);
    setInputValue("");
    let data = {
      query: inputValue.replaceAll("\n", " "),
      _ses: sessionId,
    };

    let response = await _axios.post(
        // process.env.REACT_APP_CHAT_URL || "",
      "https://n8n.management.live/webhook-test/5323b802-3a7d-4b51-9bdc-fde6b0dff99f",
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
          ___: process.env.REACT_APP_WEBHOOK_AI_KEY,
        },
      }
    );
    if (response.status === 200) {
      let _message = JSON.parse(response.data).response;
      setMessages((prev) => [
        ...prev,
        {
          content: _message,
          isUser: false,
          timestamp: new Date(),
        },
      ]);
    }
    // // Add user message
    // const newMessage: Message = {
    //   content: inputValue,
    //   isUser: true,
    //   timestamp: new Date()
    // };

    // setMessages(prev => [...prev, newMessage]);
    // setInputValue('');

    // // Simulate AI response (you can replace this with actual API calls later)
    // setTimeout(() => {
    //   const aiResponse: Message = {
    //     content: "This is a demo response. The chat functionality is not connected to a real AI backend yet.",
    //     isUser: false,
    //     timestamp: new Date()
    //   };
    //   setMessages(prev => [...prev, aiResponse]);
    // }, 1000);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e as unknown as React.FormEvent);
    }
  };

  const formatTimestamp = (date: Date) => {
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  return (
    <div className="hidden-chat">
      <div className="chat-container">
        <div className="messages-container">
          {messages.map((message, index) => (
            <div
              key={index}
              className={`message ${
                message.isUser ? "user-message" : "ai-message"
              }`}
            >
              <div className="message-content">{message.content}</div>
              <div className="message-timestamp">
                {formatTimestamp(message.timestamp)}
              </div>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>
        <form onSubmit={handleSubmit} className="input-container">
          <textarea
            ref={inputRef}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Type your message..."
            rows={1}
          />
          <button type="submit" disabled={!inputValue.trim()}>
            Send
          </button>
        </form>
      </div>
    </div>
  );
};

export default HiddenChat;
